import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Flagsmith (MK-1062): gates the "Safety Issue" checkbox in the note/transcript
 * feedback popover, the thumb-click auto-open behavior change, and the native
 * safety-issue ticket form. Default OFF; rollout via Flagsmith segment
 * overrides (e.g. "Managed Users"), never a global on/off. Flag key must match
 * the ml-scribe backend flag (MK-1063).
 */
export const useIsSafetyIssueCheckboxEnabled = () => {
  return useBooleanFlagValue('release-safety-issue-checkbox', false);
};
